module.exports = __webpack_public_path__ + "static/media/logo.e5665db5.png";